module.exports = __webpack_public_path__ + "img/superhero_pic.9330b2d8.png";